/* Restyles the existing ".gd-bg" (90-day guarantee) and ".gd-bs" (savings
   pill) elements already present in the product description into a more
   premium, e-commerce-brand look: bigger hero number, seal-style icon,
   soft gradient/shadow. The merchant's original numbers and copy are
   preserved exactly — only the surrounding markup/appearance changes.
   Safe to include on every page since it no-ops when the elements are
   absent. */
(function () {
  'use strict';

  var SHIELD_ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2 4 5v6c0 5.25 3.6 10.14 8 11.5 4.4-1.36 8-6.25 8-11.5V5l-8-3z"/><path d="M10.6 13.8 8.4 11.6l-1.4 1.4 3.6 3.6 6-6-1.4-1.4-4.6 4.6z" fill="#fff"/></svg>';

  var TAG_ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21.4 11.6 12.4 2.6c-.4-.4-.9-.6-1.4-.6H4c-1.1 0-2 .9-2 2v7c0 .5.2 1 .6 1.4l9 9c.4.4.9.6 1.4.6s1-.2 1.4-.6l7-7c.8-.8.8-2 0-2.8zM6.5 8C5.7 8 5 7.3 5 6.5S5.7 5 6.5 5 8 5.7 8 6.5 7.3 8 6.5 8z"/></svg>';

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function enhanceGuarantee(el) {
    if (el.dataset.premiumEnhanced === 'true') return;
    el.dataset.premiumEnhanced = 'true';

    var spans = el.querySelectorAll('span');
    var textSpan = spans.length > 1 ? spans[spans.length - 1] : spans[0];
    var rawHtml = textSpan ? textSpan.innerHTML : el.innerHTML;

    var lines = rawHtml
      .split(/<br\s*\/?>/i)
      .map(function (line) {
        var div = document.createElement('div');
        div.innerHTML = line;
        return (div.textContent || '').trim();
      })
      .filter(Boolean);

    var firstLine = lines[0] || '';
    var subtitle = lines.slice(1).join(' ');
    var match = firstLine.match(/^(\d+)\s*(.*)$/);
    var number = match ? match[1] : firstLine;
    var unit = match ? match[2] : '';

    el.classList.add('gd-bg--premium');
    el.innerHTML =
      '<span class="gd-bg__seal" aria-hidden="true">' +
      '<span class="gd-bg__seal-ring"></span>' +
      SHIELD_ICON +
      '</span>' +
      '<span class="gd-bg__text">' +
      '<span class="gd-bg__number">' +
      escapeHtml(number) +
      (unit ? ' <span class="gd-bg__unit">' + escapeHtml(unit) + '</span>' : '') +
      '</span>' +
      (subtitle ? '<span class="gd-bg__subtitle">' + escapeHtml(subtitle) + '</span>' : '') +
      '</span>';
  }

  function enhanceSavings(el) {
    if (el.dataset.premiumEnhanced === 'true') return;
    el.dataset.premiumEnhanced = 'true';

    var text = (el.textContent || '').trim();
    var match = text.match(/\$[\d.,]+/);
    var amount = match ? match[0] : text;
    var idx = match ? text.indexOf(amount) : -1;
    var prefix = idx > -1 ? text.slice(0, idx).trim() : '';
    var suffix = idx > -1 ? text.slice(idx + amount.length).trim() : '';

    el.classList.add('gd-bs--premium');
    el.innerHTML =
      '<span class="gd-bs__icon" aria-hidden="true">' +
      TAG_ICON +
      '</span>' +
      '<span class="gd-bs__text">' +
      (prefix ? '<span class="gd-bs__prefix">' + escapeHtml(prefix) + '</span>' : '') +
      '<span class="gd-bs__amount">' +
      escapeHtml(amount) +
      '</span>' +
      (suffix ? '<span class="gd-bs__suffix">' + escapeHtml(suffix) + '</span>' : '') +
      '</span>';
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.gd-bg:not(.gd-bg--premium)'),
      enhanceGuarantee
    );
    Array.prototype.forEach.call(
      document.querySelectorAll('.gd-bs:not(.gd-bs--premium)'),
      enhanceSavings
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
